export default __webpack_public_path__ + "static/media/plane.c35cf615.svg";